import {
  DATE_DD_MM_FORMAT,
  DirectionEnum,
  formatDate,
  type IHubBookingPreviewItem,
  type TimeZoneEnum,
} from "@ryde/shared";

export const formatHubTime = ({
  dateISO,
  timeFormat,
  timezone,
  withDate,
}: {
  dateISO: TDateISO;
  timeFormat: string;
  timezone: TimeZoneEnum;
  withDate?: boolean;
}): string =>
  formatDate({
    dateISO,
    dateFormat: withDate ? `${DATE_DD_MM_FORMAT} ${timeFormat}` : timeFormat,
    timezone,
  });

/**
 * personalBookTime = hub leg; bookTime = workplace/second-station leg.
 * Labels are "Hub: …" and "{station}: …" — no arrival/departure wording.
 */
export const resolveHubBookingTimeLines = ({
  booking,
  direction,
  secondStationName,
  timeFormat,
  timezone,
  t,
}: {
  booking: IHubBookingPreviewItem;
  direction: string;
  secondStationName?: string;
  timeFormat: string;
  timezone: TimeZoneEnum;
  t: (key: string) => string;
}): { label: string; value: string }[] => {
  const isPickUp = direction === DirectionEnum.PickUp;
  const hubTime = booking.personalBookTime;
  const stationTime = booking.bookTime;
  const stationLabel =
    secondStationName ||
    (isPickUp ? booking.destinationStationName : booking.originStationName) ||
    t("rideProduction.hubBookingsSecondStation");

  const lines: { label: string; value: string }[] = [];

  if (hubTime) {
    lines.push({
      label: t("rideProduction.hubTimeLabel"),
      value: formatHubTime({
        dateISO: hubTime,
        timeFormat,
        timezone,
        withDate: true,
      }),
    });
  }

  if (stationTime) {
    lines.push({
      label: stationLabel,
      value: formatHubTime({
        dateISO: stationTime,
        timeFormat,
        timezone,
        withDate: !hubTime,
      }),
    });
  }

  return lines;
};
